import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { Select } from '@piggytechng/component-library';
import ModalExecuteAction from './ModalExecuteAction';
import { useState } from 'react';
import { OverideSelectStyle } from '../../helpers/utils';
import useUSDRequest from '../../hooks/useUSDRequest';
import { VanReturnedPage } from '../../api/enums';
import MultiSelect from '../MultiSelect/MultiSelect';

function ModalChildren({
  closeModal,
  handleChange,
  returnForm,
  setIsOpen,
  setShowExecuteAction,
  actionColor,
  buttonText,
  text,
}: any) {
  const onButtonClick = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsOpen(false);
    setShowExecuteAction(true);
  };

  const optionV = [
    { value: 'Expired Document', label: 'Expired Document' },
    { value: 'Invalid Utility Bill', label: 'Invalid Utility Bill' },
    { value: 'Incorrect Document Type', label: 'Incorrect Document Type' },
    { value: 'Document Mismatch', label: 'Document Mismatch' },
    { value: 'Address Discrepancy', label: 'Address Discrepancy' },
    { value: 'Outdated Bank Statement', label: 'Outdated Bank Statement' },
    { value: 'Others', label: 'Others' },
  ];

  const returnedPageOptions = [
    { value: VanReturnedPage.IDENTITY, label: 'Biometric verification' },
    { value: VanReturnedPage.ADDRESS, label: 'Address information' },
    { value: VanReturnedPage.UTILITY_BILL, label: 'KYC information' },
    { value: VanReturnedPage.FINANCIAL_INFO, label: 'Financial information' },
  ];

  return (
    <div className={`modal-base general success action flex--4`}>
      <span onClick={closeModal}>&times;</span>
      <form>
        <h4>{text}</h4>
        <Select
          {...OverideSelectStyle}
          labelStyle={{ color: '#666766' }}
          label="Reason"
          placeholder="Select reason"
          options={optionV}
          value={returnForm.reason}
          onChange={(e) => handleChange({ target: { name: 'reason', value: e } })}
        />

        <div style={{ marginTop: '20px' }}>
          <MultiSelect
            labelStyle={{ color: '#666766' }}
            label="Section returned"
            placeholder="Select section"
            options={returnedPageOptions}
            value={returnForm.returnedPage}
            onChange={(selected) => handleChange({ target: { name: 'returnedPage', value: selected } })}
          />
        </div>

        <div className="flex--4 usd-details-modal-comments">
          <label>Comments (Optional)</label>
          <textarea
            name="comment"
            placeholder="Enter comments here"
            value={returnForm.comment ?? ''}
            onChange={handleChange}
          />
        </div>

        <div className="button-cont flex--2">
          <button onClick={() => setIsOpen(false)}>Cancel</button>
          <button onClick={onButtonClick} style={{ backgroundColor: actionColor }}>
            {buttonText}
          </button>
        </div>
      </form>
    </div>
  );
}

function ModalReturnUSD({ modalIsOpen, setIsOpen, action, text, actionColor, buttonText }: ModalProps) {
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { approveReturnRequest, returnForm, handleChange, isLoading } = useUSDRequest();

  function closeModal() {
    setIsOpen(false);
  }

  const actionExecuter = () => {
    approveReturnRequest(() => {
      action?.();
      setShowExecuteAction(false);
    }, 'return');
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <ModalChildren
          closeModal={closeModal}
          handleChange={handleChange}
          returnForm={returnForm}
          setIsOpen={setIsOpen}
          setShowExecuteAction={setShowExecuteAction}
          actionColor={actionColor}
          buttonText={buttonText}
          text={text}
        />
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        text={text}
        action={actionExecuter}
        actionColor={actionColor}
        isLoading={isLoading}
      />
    </>
  );
}

export default ModalReturnUSD;
